import { Component, Input } from '@angular/core';


@Component({
  selector: 'fal-visitor-info',
  templateUrl: 'visitor-info.component.html',
  styleUrls: ['visitor-info.component.scss']
})
export class VisitorInfoComponent {
  @Input() hospitalVisitorRestrictions: string[] | undefined;
  accordianActive = false;

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  toggleAccordian(event: Event) {
    const element = event.currentTarget as HTMLButtonElement;
    element.classList.toggle('active');
    this.accordianActive = !this.accordianActive;
  }
}
